import { useGetSubscriptionDetails } from './useGetSubscriptionDetails';
import useGetProductRecommendation from './useGetProductRecommendation';
import useGetNextInteractionApi from './useGetNextGenerationApi';
import { toGetPricingV2Data } from '@chegg/commerce-utils';
import { mapCountryCodeToCurrencyCode, US_CURRENCY_CODE } from '../constants';
import { useMemo } from 'react';
import { getNextInteractionPayload } from '../utils/getNextInteractionPayload';
export var useCheckout = function useCheckout(_ref) {
  var _mapCountryCodeToCurr, _nextApiInteractions$;
  var analyticsInfo = _ref.analyticsInfo,
    countryCode = _ref.countryCode,
    productConfig = _ref.productConfig,
    environment = _ref.environment,
    authorizeParams = _ref.authorizeParams;
  var _useGetSubscriptionDe = useGetSubscriptionDetails(environment),
    subscriptionDetailsLoading = _useGetSubscriptionDe.loading,
    subscriptionDetails = _useGetSubscriptionDe.data,
    writingSubscriptionError = _useGetSubscriptionDe.error;
  var _useGetProductRecomme = useGetProductRecommendation(productConfig.planCode, (_mapCountryCodeToCurr = mapCountryCodeToCurrencyCode[countryCode]) !== null && _mapCountryCodeToCurr !== void 0 ? _mapCountryCodeToCurr : US_CURRENCY_CODE),
    productRecommendation = _useGetProductRecomme.data,
    productRecommendationLoading = _useGetProductRecomme.loading,
    productRecommendationError = _useGetProductRecomme.error;
  var pricingV2Data = useMemo(function () {
    return !productRecommendationLoading && !!productRecommendation ? toGetPricingV2Data(productRecommendation, {
      countryCode: countryCode,
      productCode: productConfig.productCode,
      offerId: []
    }) : null;
  }, [productRecommendation, productRecommendationLoading]);
  var nextInteractionPayload = useMemo(function () {
    return getNextInteractionPayload({
      pricingV2Data: pricingV2Data,
      authorizeParams: authorizeParams,
      analyticsInfo: analyticsInfo
    });
  }, [pricingV2Data]);
  var _useGetNextInteractio = useGetNextInteractionApi({
      nextInteractionPayload: nextInteractionPayload,
      skip: nextInteractionPayload == undefined
    }),
    nextApiInteractions = _useGetNextInteractio.data,
    oneClickLoading = _useGetNextInteractio.loading,
    oneClickError = _useGetNextInteractio.error;
  return {
    loading: subscriptionDetailsLoading || oneClickLoading,
    subscriptionDetails: subscriptionDetails,
    oneClickPayload: nextApiInteractions !== null && nextApiInteractions !== void 0 ? nextApiInteractions : undefined,
    hasError: Boolean(!!writingSubscriptionError || !!productRecommendationError || (oneClickError === null || oneClickError === void 0 ? void 0 : oneClickError.length) || (nextApiInteractions === null || nextApiInteractions === void 0 || (_nextApiInteractions$ = nextApiInteractions.errors) === null || _nextApiInteractions$ === void 0 ? void 0 : _nextApiInteractions$.length))
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/hooks/useCheckout.js
// module id = 5221
// module chunks = 11